export const selectDefault = (state) => state.defaultReducer;
export const selectReportTypes = (state) => selectDefault(state)?.reportTypes ?? [];
export const selectReportsData = (state) => selectDefault(state)?.reportsData ?? {};
export const selectId = (state) => selectReportsData(state)?.id;
export const selectBranchId = (state) => selectReportsData(state)?.branchId;
export const selectOrganizationId = (state) => selectReportsData(state)?.organizationId;
export const selectCreated = (state) => selectReportsData(state)?.created;
export const selectStartDate = (state) => selectReportsData(state)?.startDate;
export const selectReportTypeId = (state) => selectReportsData(state)?.reportTypeId;
export const selectReportRange = (state) => selectReportsData(state)?.reportRange ?? "";
export const selectData = (state) => selectReportsData(state)?.data;
export const selectRenderConfig = (state) => selectDefault(state)?.renderConfig;
